import React from 'react';
import { inject, observer } from 'mobx-react';
import {toJS} from 'mobx';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ClientsIcon from '@material-ui/icons/BusinessCenter'
import CategoriesIcon from '@material-ui/icons/DeviceHub'
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';

import Icon from '@mdi/react'
import {
  mdiViewDashboard,
  mdiCart,
  mdiLabel,
  mdiTruckDelivery,
  mdiWallet,
  mdiAccountMultiple,
  mdiTuneVertical,
  mdiShape,
  mdiPlaylistPlus,
  mdiStar,
  mdiImage,
  mdiShapePlus,
  mdiTie,
  mdiGift,
  mdiClipboardTextOutline,
  mdiClipboardAlert,
  mdiStore,
  mdiTrafficLight,
  mdiFileDocument,
  mdiTreasureChest,
  mdiXml, mdiHexagon,
} from '@mdi/js'

import './index.scss';
import { Collapse } from '@material-ui/core';

import ClassOutlined from '@material-ui/icons/ClassOutlined'

@inject('internal')
@inject('translate')
@observer
export default class CustomDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bekoshop: false,
            elicashop: false,
            generalAboutShops: false,
        }
    }

    componentDidMount() {
        // this.setPermissions();
    }

    componentWillReceiveProps() {
        if(toJS(this.props.internal.user.data.permissions) !== undefined) {
            this.setPermissions();
        }

    }

    setPermissions() {
        this.routes = [
            {
                title: this.props.translate.i18n.GLOBAL.MENU.DASHBOARD,
                link:'/',
                icon:<Icon path={mdiViewDashboard} size={1}  />,
            },
        ]
        const permissions = toJS(this.props.internal.user.data.permissions);

        if(permissions.administrators) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.ADMINISTRATORS,
                    link:'/administrators',
                    icon:<Icon path={mdiAccountMultiple} size={1}  />,
                },
            )
        }

        if(permissions.clients) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.CLIENTS,
                    link:'/clients',
                    icon:<ClientsIcon />,
                },
            )
        }
  
      if(permissions.products) {
        this.routes.push(
          {
            title: this.props.translate.i18n.GLOBAL.MENU.PRODUCTS,
            link:'/products',
            icon:<Icon path={mdiCart} size={1}  />,
          },
        )
      }
  
      if(permissions.issue_cards) {
        this.routes.push(
          {
            title: this.props.translate.i18n.GLOBAL.MENU.ISSUE_CARDS,
            link:'/issue-cards',
            icon:<Icon path={mdiStar} size={1}  />,
          },
        )
      }
  
      if(permissions.stock_management && permissions.stock_management.view) {
        this.routes.push(
          {
            title: this.props.translate.i18n.GLOBAL.MENU.TO_STORAGE,
            link:'/to-storage',
            icon:<Icon path={mdiHexagon} size={1}  />,
          },
        )
      }
  
      if(permissions.lists_vignettes && permissions.lists_vignettes.view) {
        this.routes.push(
          {
            title: this.props.translate.i18n.GLOBAL.MENU.VIGNETTES,
            link:'/vignettes',
            icon: <ClassOutlined />
          },
        )
      }

        if(permissions.lists_parameters && permissions.lists_parameters.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.PARAMETERS,
                    link:'/parameters',
                    icon:<Icon path={mdiTuneVertical} size={1}  />,
                    // bekoshop: true
                },
            )
        }

        if(permissions.lists_categories) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.CATEGORIES,
                    link:'/categories',
                    icon:<CategoriesIcon/>,
                },
            )
        }

        if(permissions.lists_tags) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.TAGS,
                    link:'/tags',
                    icon:<Icon path={mdiLabel} size={1}  />,
                },
            )
        }
        if(permissions.lists_delivery_types) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.TRANSPORTS,
                    link:'/transports',
                    icon:<Icon path={mdiTruckDelivery} size={1}  />,
                },
            )
        }

        if(permissions.lists_payment_types) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.PAYMENTS,
                    link:'/payments',
                    icon:<Icon path={mdiWallet} size={1}  />,
                },
            )
        }

        if(permissions.service_protocols) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.SERVICE_PROTOCOLS,
                    link:'/service-protocols',
                    icon:<Icon path={mdiFileDocument} size={1}  />,
                },
            )
        }

        if(permissions.service_protocol_form) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.SERVICE_PROTOCOL_FORM,
                    link:'/service-protocol',
                    icon:<Icon path={mdiFileDocument} size={1} />,
                },
            )
        }

        if(permissions.lists_shops && permissions.lists_shops.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.SHOPS,
                    link:'/shops',
                    icon:<Icon path={mdiStore} size={1}  />,
                    general_shops: true,
                },
            )
        }

        let staticPages = toJS(this.props.internal.staticPages)
        if(staticPages !== null && staticPages.length > 0) {
            for(let i in staticPages) {
                this.routes.push(
                    {
                        title: staticPages[i].title,
                        link:`/static/${staticPages[i].slug}`,
                        icon:<Icon path={mdiFileDocument} size={1}  />,
                    },
                )
            }
        }

        // this.routes.push(
        //     {
        //         title: this.props.translate.i18n.GLOBAL.MENU.CONTACT,
        //         link:'/static/contact',
        //         icon:<Icon path={mdiContacts} size={1}  />,
        //     },
        //     {
        //         title: this.props.translate.i18n.GLOBAL.MENU.TERMS_OF_USE,
        //         link:'/static/terms-of-use',
        //         icon:<Icon path={mdiSecurity} size={1}  />,
        //     },
        // )

        if(permissions.lists_frontend_menu && permissions.lists_frontend_menu.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.MENU,
                    link:'/menu',
                    icon:<Icon path={mdiPlaylistPlus} size={1}  />,
                    bekoshop: true,
                    elicashop: true
                },
            )
        }

        if(permissions.lists_banners && permissions.lists_banners.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.BANNER,
                    link:'/banner',
                    icon:<Icon path={mdiImage} size={1}  />,
                    bekoshop: true,
                    elicashop: true                },
            )
        }

        if(permissions.top_products && permissions.top_products.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.TOP_PRODUCTS,
                    link:'/top-products',
                    icon:<Icon path={mdiStar} size={1}  />,
                    bekoshop: true,
                    elicashop: true
                },
            )
        }


        if(permissions.lists_static_sets && permissions.lists_static_sets.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.FIXED_SETS,
                    link:'/fixed-sets',
                    icon:<Icon path={mdiShape} size={1}  />,
                    bekoshop: true,
                    elicashop: true
                    // disabled: true
                },
            )
        }
        if(permissions.lists_dynamic_sets && permissions.lists_dynamic_sets.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.DYNAMIC_SETS,
                    link:'/dynamic-sets',
                    icon:<Icon path={mdiShapePlus} size={1}  />,
                    bekoshop: true,
                    elicashop: true
                    // disabled: true
                },
            )
        }

        if(permissions.customers && permissions.customers.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.CUSTOMERS,
                    link:'/customers',
                    icon:<Icon path={mdiTie} size={1}  />,
                    general_shops: true,
                    // bekoshop: true,
                    // elicashop: true
                    // disabled: true
                },
            )
        }
        //TODO: nasatvit permission pre customer-orders
        if(permissions.customers && permissions.customers.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.CUSTOMERS_ORDERS,
                    link:'/customers-orders',
                    icon:<Icon path={mdiClipboardTextOutline} size={1}  />,
                    bekoshop: true,
                    elicashop: true
                    // disabled: true,
                },
            )
        }
        if(permissions.contract_withdrawals && permissions.contract_withdrawals.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.CONTRACT_WITHDRAWALS,
                    link:'/contract-withdrawals',
                    icon:<Icon path={mdiClipboardAlert} size={1}  />,
                    bekoshop: true,
                    elicashop: true
                    // disabled: true,
                },
            )
        }

        if(permissions.lists_gifts && permissions.lists_gifts.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.GIFTS,
                    link:'/gifts',
                    icon:<Icon path={mdiGift} size={1}  />,
                    bekoshop: true,
                    elicashop: true
                    // disabled: true,
                },
            )
        }

        if(permissions.lists_customer_order_statuses && permissions.lists_customer_order_statuses.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.LIST_CUSTOMER_ORDER_STATUSES,
                    link:'/customer-order-statuses',
                    icon:<Icon path={mdiTrafficLight} size={1}  />,
                    general_shops: true,
                    // bekoshop: true,
                    // elicashop: true
                    // disabled: true,
                },
            )
        }

        if(permissions.lists_coupons && permissions.lists_coupons.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.LISTS_COUPONS,
                    link:'/coupons',
                    icon: <Icon path={mdiTreasureChest} size={1}  />,
                    general_shops: true,
                    // bekoshop: true,
                    // elicashop: true
                    // disabled: true,
                },
            )
        }

        if(permissions.lists_xml_exports && permissions.lists_xml_exports.view) {
            this.routes.push(
                {
                    title: this.props.translate.i18n.GLOBAL.MENU.LISTS_XML_EXPORTS,
                    link:'/xml-exports',
                    icon: <Icon path={mdiXml} size={1}  />,
                    general_shops: true,
                },
            )
        }

    }

    routes = []

    handleChangeModule = (data,shop = "") => {
        // RouteConfig.push(url)
        if(shop === "beko") {
            this.props.internal.pushRoute(`/2`+data.link)
        }
        else if(shop === 'elica') {
            this.props.internal.pushRoute(`/3`+data.link)
        }
        else {
            this.props.internal.pushRoute(data.link)
        }
        // this.props.internal.changeUrl(data);
        this.props.onClose();
    }

    handleClickCollapse = (field) => {
        this.setState(state => ({ [field]: !state[field] }));
      };

    render() {
        let activeMoudle = "/" + toJS(this.props.internal.route.link).split('/')[1]
        activeMoudle = activeMoudle.split("?")[0]
        let bekoshopMenu = []
        let elicashopMenu = []
        let generalAboutShops = []
        return (
            <Drawer
                open={this.props.open}
                // variant="permanent"
                // className={'drawer'}
                onClose={this.props.onClose}
                // onClose={this.handleClose}
            >
                <List component="nav">
                {/* <img src={logo} alt="logo" height="50" style={{paddingLeft: "24px"}}/> */}
                {this.routes.map((data) => {
                    if(data.general_shops) {
                        generalAboutShops.push(
                            <ListItem
                                button
                                key={data.link}
                                onClick={() => this.handleChangeModule(data)}
                                className={data.link === this.props.internal.route.link || data.link === activeMoudle ? " active" : ""}
                                disabled={data.disabled}
                            >
                                <ListItemIcon>
                                    {data.icon}
                                </ListItemIcon>
                                <ListItemText primary={data.title} className={'primary-text'}/>
                            </ListItem>
                        )
                    }

                    if(data.bekoshop) {
                        bekoshopMenu.push(
                            <ListItem
                                button
                                key={data.link}
                                onClick={() => this.handleChangeModule(data, 'beko')}
                                className={"/2"+data.link === (this.props.internal.route.link).split("?")[0] || data.link === activeMoudle ? " active" : ""}
                                disabled={data.disabled}
                            >
                                <ListItemIcon>
                                    {data.icon}
                                </ListItemIcon>
                                <ListItemText primary={data.title} className={'primary-text'}/>
                            </ListItem>
                        )
                    }

                    if(data.elicashop) {
                        elicashopMenu.push(
                            <ListItem
                                button
                                key={data.link}
                                onClick={() => this.handleChangeModule(data, 'elica')}
                                className={"/3"+data.link === (this.props.internal.route.link).split("?")[0] || data.link === activeMoudle ? " active" : ""}
                                disabled={data.disabled}
                            >
                                <ListItemIcon>
                                    {data.icon}
                                </ListItemIcon>
                                <ListItemText primary={data.title} className={'primary-text'}/>
                            </ListItem>
                        )
                    }

                    if(!data.hasOwnProperty("elicashop") && !data.hasOwnProperty("bekoshop") && !data.hasOwnProperty("general_shops") ){
                        return (
                            <ListItem
                                button
                                key={data.link}
                                onClick={() => this.handleChangeModule(data)}
                                className={data.link === this.props.internal.route.link || data.link === activeMoudle ? " active" : ""}
                            >
                                <ListItemIcon>
                                    {data.icon}
                                </ListItemIcon>
                                <ListItemText primary={data.title} className={'primary-text'}/>
                            </ListItem>
                        );
                    }
                })}

                    {generalAboutShops.length ?
                    <ListItem button onClick={() => this.handleClickCollapse('generalAboutShops')}>
                        <ListItemText  primary={this.props.translate.i18n.GLOBAL.BUTTONS.GENERAL_SHOPS} className={'primary-text title'}/>
                        {this.state.generalAboutShops ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    :
                    null
                    }
                    <Collapse in={this.state.generalAboutShops} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {generalAboutShops}
                        </List>
                    </Collapse>
                    {bekoshopMenu.length ?
                    <ListItem button onClick={() => this.handleClickCollapse('bekoshop')}>
                        <ListItemText  primary="Bekoshop" className={'primary-text title'}/>
                        {this.state.bekoshop ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    :
                    null
                    }
                    <Collapse in={this.state.bekoshop} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {bekoshopMenu}
                        </List>
                    </Collapse>

                    {elicashopMenu.length ?
                    <ListItem button onClick={() => this.handleClickCollapse('elicashop')}>
                        <ListItemText  primary="Elicashop" className={'primary-text title'}/>
                        {this.state.elicashop ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    :
                    null
                    }
                    <Collapse in={this.state.elicashop} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {elicashopMenu}
                        </List>
                    </Collapse>

                </List>

            </Drawer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/basic/customDrawer/index.js